import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

import {
  Container,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Alert,
  Card,
  CardTitle,
  CardBody
} from "shards-react"

import { Alert as EvergreenAlert, Pagination } from "evergreen-ui"

// View Components
import MobileView from "../common/mobileView"
import BrowserView from "../common/browserView"

import CsecMenuTray from "../csec/csecMenuTray"

// Video Resources
import StudentVideo from "../videos/csec.mp4"

import { routify } from "../js/routify"
import { getCountry } from "../js/getCountry"
import { isMobile } from "react-device-detect"

import { Table } from "react-bootstrap"

// Files
import PDF from "../common/filePDF"

class Subjects extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      country: getCountry(this.props.pageContext.countryCode),
      routes: require("../data/routes.json")
    }
  }

  render() {
    const csec = require("../data/programmes/csec.json")

    const Syllabus = props => (
      <>
        <h4>Syllabus</h4>

        <br />
        <Table bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Theme</th>
            </tr>
          </thead>
          <tbody>
            {!this.props.pageContext.sections
              ? null
              : this.props.pageContext.sections.map((section, index) => (
                  <tr key={section.id}>
                    <td>{index + 1}</td>
                    <td>
                      <a href={section.href}>{section.title}</a>
                    </td>
                  </tr>
                ))}
          </tbody>
        </Table>

        <PDF
          title="Download Syllabus with Specimen Paper & Mark Scheme"
          href={this.props.pageContext.syllabus}
        />
      </>
    )

    const Video = () => (
      <video
        style={{ width: "100%" }}
        preload="auto"
        autoPlay={true}
        loop
        muted
      >
        <source src={StudentVideo} type="video/mp4" />
      </video>
    )

    const NoticeItem = props => (
      <>
        <br />
        <div style={{ listStyleType: "none" }}>
          <div>
            <h5>{props.title}</h5>
            <div dangerouslySetInnerHTML={{ __html: props.description }} />
          </div>
        </div>
      </>
    )

    const Notices = () => (
      <Card>
        <CardBody>
          <h5>Update Centre</h5>

          {this.props.pageContext.notices ? (
            this.props.pageContext.notices.map(notice => (
              <NoticeItem
                key={notice.id}
                title={notice.title}
                description={notice.description}
              />
            ))
          ) : (
            <>
              <p>No updates available</p>
            </>
          )}
        </CardBody>
      </Card>
    )

    return (
      <Layout countryCode={this.props.pageContext.countryCode || "JM"}>
        <Seo
          title={`CSEC ${this.props.pageContext.name} Classes`}
          countryCode={this.props.pageContext.countryCode || "JM"}
          description={`Enroll in our online CXC CSEC ${this.props.pageContext.name} classes starting ${this.props.pageContext.startDate}. Classes cost ${this.props.pageContext.cost}. ${this.props.pageContext.promotion}`}
        />

        <MobileView>
          <Video />
        </MobileView>

        <Container>
          <Row>
            <Col md={6}>
              <Breadcrumb>
                <BreadcrumbItem>
                  <a
                    href={routify(
                      this.props.pageContext.countryCode,
                      this.state.routes.home
                    )}
                  >
                    Home
                  </a>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <a
                    href={routify(
                      this.props.pageContext.countryCode,
                      this.state.routes.csec
                    )}
                  >
                    CSEC
                  </a>
                </BreadcrumbItem>
                <BreadcrumbItem active>
                  {this.props.pageContext.name}
                </BreadcrumbItem>
              </Breadcrumb>
              <h3>CSEC {this.props.pageContext.name}</h3>

              <CsecMenuTray
                countryCode={this.props.pageContext.countryCode || "JM"}
              />

              <p>{this.props.pageContext.overview}</p>

              <p>{csec.description}</p>

              <EvergreenAlert
                className="text-primary"
                intent="none"
                title={`Classes begin ${this.props.pageContext.startDate}.`}
                marginBottom={32}
              />

              <p>Enrolled students get access to:</p>

              <ul className="ul pt-3">
                <li>2-3 hours of class time weekly for each subject</li>
                <li style={{ paddingTop: "15px" }}>Weekly assignments</li>
                <li style={{ paddingTop: "15px" }}>Monthly mock exams</li>
                <li style={{ paddingTop: "15px" }}>
                  Monthly progress reports for parents
                </li>
                <li style={{ paddingTop: "15px" }}>Virtual textbooks</li>
                <li style={{ paddingTop: "15px" }}>
                  Additional virtual class materials
                </li>
              </ul>
            </Col>
            <Col md={6}>
              <BrowserView>
                <br />
                <Video />
              </BrowserView>

              <br />
              <Alert
                theme={isMobile ? "primary" : "primary"}
                className={isMobile ? "break-container" : ""}
              >
                <br />
                <h5 className="text-light">Tuition & Fees</h5>

                <p>{this.props.pageContext.cost}</p>
                <p>{this.props.pageContext.costDescription}</p>

                <i class="fa-solid fa-circle-info pr-2"></i>
                {this.props.pageContext.promotion}
                <br />
                <br />
              </Alert>

              <br />
              <Syllabus />
            </Col>
          </Row>

          <br />
          <br />
          <Notices />
        </Container>
      </Layout>
    )
  }
}

export default Subjects
